export const HOMEOWNERS_BASE_URL = '/homeowners-insurance/quotes';
export const RENTERS_URL = '/renters-offers';
